import React from 'react'

interface UltrasoundFrameProps {
  children?: React.ReactNode
  size?: number
  className?: string
}

const UltrasoundFrame: React.FC<UltrasoundFrameProps> = ({ 
  children, 
  size = 200, 
  className = '' 
}) => {
  return (
    <div className={`ultrasound-frame ${className}`} style={{ width: size, height: size * 0.75 }}>
      <svg
        width={size}
        height={size * 0.75}
        viewBox="0 0 200 150"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient id="screenGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#0f0f0f" />
            <stop offset="100%" stopColor="#1a1a1a" />
          </linearGradient>
          <pattern id="scanLines" patternUnits="userSpaceOnUse" width="1" height="2">
            <rect width="1" height="1" fill="rgba(0,255,0,0.1)" />
            <rect y="1" width="1" height="1" fill="transparent" />
          </pattern>
        </defs>
        
        {/* Monitor Frame */}
        <rect x="10" y="10" width="180" height="130" rx="5" fill="#2d3748" stroke="#4a5568" strokeWidth="2" />
        
        {/* Screen */}
        <rect x="20" y="20" width="160" height="110" rx="3" fill="url(#screenGradient)" />
        
        {/* Scan Lines Effect */}
        <rect x="20" y="20" width="160" height="110" fill="url(#scanLines)" opacity="0.3" />
        
        {/* Screen Border */}
        <rect x="20" y="20" width="160" height="110" rx="3" fill="none" stroke="#00ff00" strokeWidth="1" opacity="0.5" />
        
        {/* Medical Info Display */}
        <text x="25" y="35" fontFamily="monospace" fontSize="6" fill="#00ff00" opacity="0.7">
          ULTRASOUND SCAN
        </text>
        <text x="25" y="125" fontFamily="monospace" fontSize="5" fill="#00ff00" opacity="0.5">
          12-15 WEEKS • NUB THEORY ANALYSIS
        </text>
        
        {/* Corner Markers */}
        <g stroke="#00ff00" strokeWidth="1" fill="none" opacity="0.6">
          <path d="M 25 25 L 30 25 M 25 25 L 25 30" />
          <path d="M 175 25 L 170 25 M 175 25 L 175 30" />
          <path d="M 25 125 L 30 125 M 25 125 L 25 120" />
          <path d="M 175 125 L 170 125 M 175 125 L 175 120" />
        </g>
        
        {/* Scanning Line Animation */}
        <line x1="20" y1="50" x2="180" y2="50" stroke="#00ff00" strokeWidth="1" opacity="0.8">
          <animate attributeName="y1" values="20;130;20" dur="3s" repeatCount="indefinite" />
          <animate attributeName="y2" values="20;130;20" dur="3s" repeatCount="indefinite" />
          <animate attributeName="opacity" values="0.2;0.8;0.2" dur="3s" repeatCount="indefinite" />
        </line>
        
        {/* Control Panel */}
        <rect x="185" y="20" width="10" height="110" rx="2" fill="#374151" />
        <circle cx="190" cy="30" r="2" fill="#ef4444" />
        <circle cx="190" cy="40" r="2" fill="#22c55e" />
        <circle cx="190" cy="50" r="2" fill="#3b82f6" />
        
        {/* Status Indicators */}
        <circle cx="190" cy="70" r="1" fill="#fbbf24">
          <animate attributeName="opacity" values="0.3;1;0.3" dur="1s" repeatCount="indefinite" />
        </circle>
        <circle cx="190" cy="80" r="1" fill="#10b981">
          <animate attributeName="opacity" values="1;0.3;1" dur="1.5s" repeatCount="indefinite" />
        </circle>
      </svg>
      
      {/* Content overlay */}
      {children && (
        <div 
          style={{
            position: 'absolute',
            top: '15%',
            left: '12%',
            width: '76%',
            height: '70%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#00ff00',
            fontFamily: 'monospace'
          }}
        >
          {children}
        </div>
      )}
    </div>
  )
}

export default UltrasoundFrame
